import React, { useEffect } from 'react';
import {
  Box,
  Card,
  Typography,
  Divider,
  Button,
  Container,
  Paper,
  IconButton,
  Stack,
  Link
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
//import { SignInSignUpUI } from '../iam/Signin';
import { GetUserTypePinPNG } from '../markers/MMMarkers';
import { PinPNGComponent } from '../MessageProfile';
import { useAuth } from 'react-oidc-context';
import { baseName, condition } from '../..';
import { useNavigate } from "react-router-dom";

export const ConfirmationCard: React.FC<{ scrollUp: ()=> void }> = ({scrollUp} ) => {
  const [copied, setCopied] = React.useState(false);
  const navigate = useNavigate()
  const auth = useAuth()
  const referralLink = 'https://www.polygonhealth.com/map/multiple-myeloma/sign-up-for-clinical-trials';

  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  //let pinPNG = GetUserTypePinPNG('P')
  useEffect(() => {
    scrollUp()
  }, [scrollUp]);
  return (
    <Container sx={{ alignItems: 'center', py: 0,  px:0, mt: 2 }}>
      <Paper
        elevation={2}
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          overflow: 'hidden',
          padding: 0,
          //backgroundColor: 'red'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 3,
            pb: 2,
            mt:-2 
                   }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 48,
              color: '#6366F1',
              mb: 2
            }}
          />
          <Typography variant="h7"  sx={{ textAlign: 'center' }} gutterBottom>
          Thank you. Massive Bio will be following up with you soon.
          </Typography>
          { !auth.isAuthenticated && <>
            <Divider orientation="horizontal" flexItem />
            <Typography variant="h6" fontWeight="bold" sx={{ mt:2, px:2, textAlign: 'center' }} gutterBottom>
            Join {condition} Patient Connect community
            </Typography>
          <Button variant="contained" sx={{ borderRadius: 8, color: 'white', backgroundColor: '#656EFF' }} onClick={() => {
            navigate('/signin')
          }} disableElevation>
            Sign in
          </Button></>}
        </Box>



        <Divider />

        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          
          <Typography variant="h6" color="text.secondary" gutterBottom sx={{  }}>
          Know someone who could benefit from clinical trial matching?  Send them this link
            {' '}
            <Link 
              href={referralLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              sx={{ 
                wordBreak: 'break-all',  
              }}
            >
              {referralLink}
            </Link>
          </Typography>
          <Button
            variant="outlined"
            size="small"
            startIcon={<ContentCopyIcon />}
            onClick={handleCopyLink}
            sx={{
              fontSize: { xs: 16, sm: 16, md: 18 },
              borderRadius: 1,
              textTransform: 'none',
              borderColor: '#e0e0e0',
              color: 'text.secondary',
              '&:hover': {
                borderColor: '#bdbdbd',
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </Button>
        </Box>

        <Box
          sx={{
            backgroundColor: '#f9f9f9',
            p: 2,
            borderTop: '1px dotted #e0e0e0'
          }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            Have any questions? Contact us at{' '}
            <Box component="span" sx={{ color: 'primary.main' }}>
              contact@polygonhealth.com
            </Box>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

//export default ConfirmationCard;